import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";
import {RankField} from "../fields";

const ContentForm = (props) => {
    const {data, onChange: onSync} = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = modified.ranks && modified.ranks.length > 0
        && sortingUtils.isSortable(modified.order);

        onSync(modified);
    };

    return <div className="order-form">
        <div className="field top-margin">
            <RankField
                value={forms.sanitizeValue(data.ranks)}
                onChange={(value) => onChange("ranks", value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Index"
                type="number"
                value={forms.sanitizeValue(data.order)}
                onChange={(event) => onChange("order", event.target.value)}
                inputProps={{
                    step: 1,
                    min: 0,
                }}
            />
        </div>
    </div>
}

export default ContentForm;
